import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/circleci/project/layouts/default.vue").then(m => m.default || m)),
  legacy: defineAsyncComponent(() => import("/home/circleci/project/layouts/legacy.vue").then(m => m.default || m)),
  none: defineAsyncComponent(() => import("/home/circleci/project/layouts/none.vue").then(m => m.default || m)),
  print: defineAsyncComponent(() => import("/home/circleci/project/layouts/print.vue").then(m => m.default || m)),
  progress: defineAsyncComponent(() => import("/home/circleci/project/layouts/progress.vue").then(m => m.default || m))
}